<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';

import { useAlert } from 'dashboard/composables';
import ChatvidaWhatsappChannel from 'dashboard/api/channel/chatvidaWhatsappChannel';

import Banner from 'dashboard/components-next/banner/Banner.vue';

const props = defineProps({
  inboxId: { type: [String, Number], required: true },
});

const { t } = useI18n();
const store = useStore();
const isMigrating = ref(false);

const migrate = async () => {
  isMigrating.value = true;
  try {
    await ChatvidaWhatsappChannel.adopt(props.inboxId);
    // Recarrega a caixa para a tela trocar este aviso pelo bloco de conexao.
    await store.dispatch('inboxes/get');
    useAlert(t('INBOX_MGMT.CHATVIDA_WHATSAPP.MIGRATE.SUCCESS'));
  } catch (error) {
    useAlert(
      error.response?.data?.error ||
        t('INBOX_MGMT.CHATVIDA_WHATSAPP.MIGRATE.ERROR')
    );
  } finally {
    isMigrating.value = false;
  }
};
</script>

<template>
  <Banner
    color="blue"
    class="mb-6 rounded-xl"
    :action-label="
      isMigrating
        ? $t('INBOX_MGMT.CHATVIDA_WHATSAPP.MIGRATE.IN_PROGRESS')
        : $t('INBOX_MGMT.CHATVIDA_WHATSAPP.MIGRATE.ACTION')
    "
    @action="migrate"
  >
    {{ $t('INBOX_MGMT.CHATVIDA_WHATSAPP.MIGRATE.DESCRIPTION') }}
  </Banner>
</template>
